import { Component, inject, input } from '@angular/core';

import { StorefrontPage } from '../../model/storefront-page';
import { SeoService } from '../../service/seo.service';
import { WebsiteService } from '../../service/website.service';

@Component({
  selector: 'questions-page',
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Title Page -->
    <section class="bg-title-page p-t-15 p-b-16 flex-col-c-m">
      <h1 class="l-text2 t-center">
        Запитання
      </h1>
    </section>

    <!-- content page -->
    <section class="bgwhite p-t-66 p-b-38">
      <div class="container">
        <div class="row">
          <div class="col-md-8 p-b-30">
            <h3 class="m-text26 p-t-15 p-b-16" id="order-state">
              Який стан мого замовлення?
            </h3>
            <p class="p-b-28">
              Щоб дізнатись стан Вашого замовлення, будь ласка, зателефонуйте за номером
              <a class="s-text7" [href]="'tel:' + website().phone">{{website().phone}}</a>
            </p>
          </div>
          <div class="col-md-8 p-b-30">
            <h3 class="m-text26 p-t-15 p-b-16" id="return-policy">
              На які групи товарів розповсюджується право обміну/повернення у 14-денний термін?
            </h3>
            <p class="p-b-28">
              Згідно українського законодавства, право повернення товару розповсюджується на усі товари,
              за винятком:
            </p>
            <div class="bo13 p-l-29 m-l-9 p-b-10">
              <p class="p-b-11">
                ...<br>
                пір'яно-пухові вироби<br>
                тканини<br>
                білизна натільна<br>
                білизна постільна<br>
                панчішно-шкарпеткові вироби<br>
                ...<br>
              </p>

              <span class="s-text7">
                -
                <a target="_blank" rel="noopener noreferrer"
                  href="http://zakon5.rada.gov.ua/laws/show/172-94-%D0%BF">
                  додаток №3 до постанови КМУ від 19 березня 1994 р. №172
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    `
})
export class QuestionsPageComponent {

  readonly data = input.required<StorefrontPage>();
  readonly website = inject(WebsiteService).current;

  constructor() {
    inject(SeoService).page(this.data, true);
  }

}
